export enum NewsNewTag {
  EVENTS = 'EVENTS',
  MILESTONE = 'MILESTONE',
}
